export const RecordText = (record): string => {
  return record ? '<div class="cart_balloon__record success">Шиномонтаж сегодня/завтра</div>' : '';
};
